
import { useMediaMonitoring } from '@/hooks/useMediaMonitoring';
import { useFinancialReporting } from '@/hooks/useFinancialReporting';
import { calculateRiskRating, RiskLevel } from '@/utils/riskAssessment';
import { Review } from '@/lib/types';

interface CompanyRiskDataProps {
  companyName: string;
  reviewCount: number;
  reviews: Review[];
}

export const useCompanyRiskData = ({ companyName, reviewCount, reviews }: CompanyRiskDataProps) => {
  // Fetch additional data for comprehensive risk assessment
  const { articles } = useMediaMonitoring(companyName);
  const { financialData } = useFinancialReporting(companyName);
  
  // Use the algorithm to determine risk rating
  const riskLevel: RiskLevel = calculateRiskRating({
    companyName,
    reviewCount,
    employeeReviews: reviews,
    mediaArticles: articles,
    financialData: financialData
  });

  return {
    articles,
    financialData,
    riskLevel
  };
};
